import React, { useMemo } from 'react';

export const useParseHtmlLineBreaks = (text: string): React.ReactNode => {
  return useMemo(() => {
    const parts = text.split(/<br\s*\/?>/i);
    return parts.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < parts.length - 1 && <br />}
      </React.Fragment>
    ));
  }, [text]);
};
